import React, { useMemo } from "react";
import { headphonesXMarkLight, headphonesXMarkSolid } from "../customIconDefinitions/HeadPhonesXMark";
import { faHeadphones } from "web-fortawesome/npm/pro-light";
import { faHeadphones as faHeadphonesSolid } from "web-fortawesome/npm/pro-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Audio
 * @param props - props from interface IPresenceIconProps
 * @returns - the audio icon
 */
export const PresenceIconAudio = (props: IPresenceIconProps): React.ReactElement => {
	const icon = useMemo(() => {
		if (!props.callProtection && !props.lineForwarded) {
			if (props.type === "busy")
				return faHeadphonesSolid;
			else
				return faHeadphones;
		} else if (props.callProtection) {
			if (props.type === "busy")
				return headphonesXMarkSolid;
			else
				return headphonesXMarkLight;
		}
		return faHeadphones;
	}, [props.type, props.callProtection, props.lineForwarded]);

	return (
		<FontAwesomeIcon
			className={props.className}
			icon={icon}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
